import { createContext } from 'react';

import DeviceGroup from '../interfaces/deviceGroup';

export interface DeviceGroupContextValue {
	isLoading: boolean;
	hasError: boolean;
	deviceGroup: DeviceGroup | undefined;
	overwrittenClientId: string | undefined;
}

const DeviceGroupContext = createContext<DeviceGroupContextValue>({
	isLoading: true,
	hasError: false,
	deviceGroup: undefined,
	overwrittenClientId: undefined,
});

export default DeviceGroupContext;
